import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { LandingConfig, LandingForm, LandingSections } from '../../../../domain/landing-config.interface';
import { formCode, isIconName, normalizeSections } from './shared/landing-utils';

// Base de los componentes de diseño de landing: reciben el config, emiten el formulario elegido
// y solo pintan; el flujo (confirmación, visor, /fill) lo maneja LandingComponent.
@Directive()
export abstract class LandingDesignBase {
  @Input() set config(config: LandingConfig) {
    this._config = config;
    this.sections = normalizeSections(config);
    this.selectedSection = 0;
  }
  get config(): LandingConfig {
    return this._config;
  }

  @Output() selectForm = new EventEmitter<LandingForm>();

  sections: LandingSections[] = [];
  // Solo lo usan los diseños con pestañas
  selectedSection = 0;
  private _config: LandingConfig;

  get forms(): LandingForm[] {
    return this.sections[this.selectedSection]?.forms || [];
  }

  isIconName = isIconName;
  formCode = formCode;
}
